import React from "react"

import {
  Table,
  TableBody,
} from "@mui/material"

import TimerHeader from "components/TimerTable/TimerHeader"
import TimerRow from "components/TimerTable/TimerRow"


function huntNameSort(rows, order) {
  var rowArray = [];
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [Math.ceil(parseInt(rows[j].dataset.sortDefault) / 10000).toString() + rows[j].dataset.sortName.toLowerCase(), rows[j]];
  }
  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -order : order;
  });

  return rowArray;
}

function regionNameSort(rows, order) {
  var rowArray = [];
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [rows[j].dataset.sortRegion.toLowerCase(), rows[j]];
  }
  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -order : order;
  });
  
  return rowArray;
}

function maxTimeSort(rows, order) {
  var rowArray = [];
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [rows[j].dataset.sortMinTime, rows[j]];
  }

  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -order : order;
  });

  return rowArray;
}

function maxPercentSort(rows, order) {
  var rowArray = [];
  const currentTime = new Date().getTime();
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [(currentTime - rows[j].dataset.sortMinTime) / (rows[j].dataset.sortMaxTime - rows[j].dataset.sortMinTime), rows[j]];
  }

  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -order : order;
  });

  return rowArray;
}

function defaultSort(rows) {
  var rowArray = [];
  for (var j = 0; j < rows.length; j++) {
    rowArray[rowArray.length] = [parseInt(rows[j].dataset.sortDefault), rows[j]];
  }

  rowArray.sort(function(a,b) {
    if (a[0]==b[0]) return 0;
    return a[0] < b[0] ? -1 : 1;
  });

  return rowArray;
}

const TimerTable = ({name, huntInfo, audioRef, children}) => {
  var defaultHeaders = [];
  
  const onHandleSorting = (columnName, order) => {
    const table = document.getElementById(name);
    const rows = table.tBodies[0].rows;

    switch (columnName) {
      case "tableHuntName": {
        if (order == 1) {
          const rowArray = huntNameSort(rows, order);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }
          
        } else if (order == -1) {
          const rowArray = huntNameSort(rows, order);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }

        } else {
          const rowArray = defaultSort(rows);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }
        }
      }
      break;
      case "tableRegionName": {
        if (order == 1) {
          const rowArray = regionNameSort(rows, order);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }
          
        } else if (order == -1) {
          const rowArray = regionNameSort(rows, order);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }

        } else {
          const rowArray = defaultSort(rows);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }

        }
      }
      break;
      case "tableTimer": {
        if (order == 1) {
          const rowArray = maxPercentSort(rows, -1);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }
          
        } else if (order == -1) {
          const rowArray = maxTimeSort(rows, 1);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }

        } else {
          const rowArray = defaultSort(rows);
          var tb = table.tBodies[0];
          for (var j = 0; j < rowArray.length; j++) {
            tb.appendChild(rowArray[j][1]);
          }

        }
      }
    }
  }

  if (name == "SHuntTable") {
    defaultHeaders = [
      {name: "tableHuntName", suffix:"", width: "40%", minWidth: "250px", align: "left", callback: onHandleSorting},
      {name: "tableRegionName", suffix:"", width: "30%", minWidth: "200px", align: "left", callback: onHandleSorting},
      {name: "tableTimer", suffix:"", width: "15%", minWidth: "200px", align: "center", callback: onHandleSorting},
      {name: "tableSecondaryTimer", suffix:"", width: "15%", align: "center", callback: null},
    ];
  } else if (name == "AHuntTable") {
    defaultHeaders = [
      {name: "tableHuntName", suffix:"", width: "40%", minWidth: "250px", align: "left", callback: onHandleSorting},
      {name: "tableRegionName", suffix:"", width: "30%", minWidth: "200px", align: "left", callback: onHandleSorting},
      {name: "tableTimer", suffix:"", width: "30%", align: "center", callback: onHandleSorting},
    ];
  }

  return (
    <Table id={name} style={{padding: 0}}>
      <TimerHeader defaultHeaders={defaultHeaders} style={{position: "fixed"}}></TimerHeader>
      <TableBody>
        {huntInfo.map((hunt) => {
          return (
            <TimerRow key={hunt.worldName + "_" + hunt.huntName} audioRef={audioRef} timer={hunt}>
            </TimerRow>
          )
        })}
      </TableBody>
      
    </Table>
  );
};

export default TimerTable;